module.exports = kolibriGlobal.coreVue.components.PointsIcon;